<script setup>
import { onBeforeUnmount, onMounted, ref } from "vue";
import Icon from "@components/icons/Icon.vue";
import { useAuthStore } from "@composables/use_auth_store";
import {
  encriptar,
  encriptarCampo,
} from "@composables/use_encript.js";

const { token, getTokenStatus, cliente } = useAuthStore();

const showMenu = ref(false);
const menuRef = ref(null);
const soloPirotecnia = ref(false);

onMounted(() => {
  document.addEventListener("click", onClickOutside, true);
  const dominioURL = window.location.href;
  soloPirotecnia.value = dominioURL.includes("?pirotecnia");
});

onBeforeUnmount(() => {
  document.removeEventListener("click", onClickOutside, true);
});

function onClickOutside(event) {
  if (
    showMenu.value &&
    menuRef.value &&
    !menuRef.value.contains(event.target)
  ) {
    showMenu.value = false;
  }
}

function clearLocalStorage() {
  localStorage.setItem(encriptarCampo("token"), encriptar(""));
  localStorage.setItem(encriptarCampo("cliente"), encriptar(""));
  localStorage.setItem(encriptarCampo("email"), encriptar(""));
  localStorage.setItem(encriptarCampo("saleId"), encriptar(""));
  localStorage.setItem(encriptarCampo("preferenceId"), encriptar(""));
  localStorage.setItem(encriptarCampo("cartModified"), encriptar("false"));
}

function logout() {
  clearLocalStorage();
  getTokenStatus();
  alert("Sesión cerrada correctamente");
  window.location.href = window.location.origin;
}

function toggleMenu() {
  showMenu.value = !showMenu.value;
}
</script>

<template>
  <div class="relative flex items-center" ref="menuRef">
    
    <!-- User Trigger Button -->
    <button
      type="button"
      class="flex items-center justify-center w-8 h-8 sm:w-auto sm:h-auto sm:gap-2 sm:px-3 sm:py-1.5 rounded-full bg-white/20 hover:bg-white/30 transition-all duration-200 focus:outline-none group border border-white/30"
      @click="toggleMenu"
    >
      <Icon :name="'user'" :width="22" class="text-white brightness-0 invert" />
      <span class="hidden sm:inline text-white text-[13px] font-semibold">
        {{ cliente?.nombre || 'Mi cuenta' }}
      </span>
      <Icon 
        :name="'down'" 
        :width="12" 
        class="hidden sm:inline text-white brightness-0 invert transition-transform duration-200" 
        :class="showMenu ? 'rotate-180' : ''"
      />
    </button>

    <!-- Dropdown Menu (Matching others) -->
    <transition
      enter-active-class="transition ease-out duration-200 origin-top-right"
      enter-from-class="opacity-0 scale-95 translate-y-1"
      enter-to-class="opacity-100 scale-100 translate-y-0"
      leave-active-class="transition ease-in duration-150 origin-top-right"
      leave-from-class="opacity-100 scale-100 translate-y-0"
      leave-to-class="opacity-0 scale-95 translate-y-1"
    >
      <div
        v-if="showMenu"
        class="absolute top-[calc(100%+10px)] right-0 z-[9999] bg-white rounded-2xl shadow-[0_20px_60px_-12px_rgba(0,0,0,0.25)] border border-slate-100 py-2 min-w-[200px]"
      >
        <!-- Header -->
        <div class="flex items-center gap-2 px-4 pb-2 pt-1 border-b border-slate-100 mb-1">
          <span class="text-[10px] font-bold uppercase tracking-widest text-slate-400">Usuario</span>
        </div>

        <!-- Links -->
        <div class="flex flex-col gap-0.5 px-2">
          <a
            :href="`${soloPirotecnia ? '/mis_compras/?pirotecnia' : '/mis_compras'}`"
            class="group flex items-center gap-3 px-3 py-2.5 rounded-xl text-[13px] font-medium text-slate-700 hover:bg-[#e41b1b] hover:text-white transition-all duration-150"
            @click="showMenu = false"
          >
            <span>Mis compras</span>
          </a>
          <a
            :href="`${soloPirotecnia ? '/change_password/?pirotecnia' : '/change_password'}`"
            class="group flex items-center gap-3 px-3 py-2.5 rounded-xl text-[13px] font-medium text-slate-700 hover:bg-[#e41b1b] hover:text-white transition-all duration-150"
            @click="showMenu = false"
          >
            <span>Cambiar contraseña</span>
          </a>
          <button
            class="group flex items-center gap-3 px-3 py-2.5 rounded-xl text-[13px] font-medium text-[#e41b1b] hover:bg-[#e41b1b] hover:text-white transition-all duration-150 text-left"
            @click="logout"
          >
            <span>Cerrar Sesión</span>
          </button>
        </div>
      </div>
    </transition>

  </div>
</template>

<style scoped>
/* Ensure icons inherit color properly if they are SVGs */
:deep(img) {
  transition: filter 0.15s ease;
}

.group:hover :deep(img) {
  filter: brightness(0) invert(1) !important;
}
</style>
